export enum WidgetMode {
    View = 0,
    Edit = 1,
    Select = 2,
    Checkout = 3
}
